/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type DeleteClusterOrgAuthClusterResponse429ResponseBodyData = {
  message: string;
};

/**
 * Rate limited
 */
export class DeleteClusterOrgAuthClusterResponse429ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: DeleteClusterOrgAuthClusterResponse429ResponseBodyData;

  constructor(
    err: DeleteClusterOrgAuthClusterResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "DeleteClusterOrgAuthClusterResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type DeleteClusterOrgAuthClusterResponse409ResponseBodyData = {
  message: string;
};

/**
 * Conflict
 */
export class DeleteClusterOrgAuthClusterResponse409ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: DeleteClusterOrgAuthClusterResponse409ResponseBodyData;

  constructor(
    err: DeleteClusterOrgAuthClusterResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "DeleteClusterOrgAuthClusterResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type DeleteClusterOrgAuthClusterResponse404ResponseBodyData = {
  message: string;
};

/**
 * Not found
 */
export class DeleteClusterOrgAuthClusterResponse404ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: DeleteClusterOrgAuthClusterResponse404ResponseBodyData;

  constructor(
    err: DeleteClusterOrgAuthClusterResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "DeleteClusterOrgAuthClusterResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type DeleteClusterOrgAuthClusterResponseResponseBodyData = {
  message: string;
};

/**
 * Forbidden
 */
export class DeleteClusterOrgAuthClusterResponseResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: DeleteClusterOrgAuthClusterResponseResponseBodyData;

  constructor(
    err: DeleteClusterOrgAuthClusterResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "DeleteClusterOrgAuthClusterResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type DeleteClusterOrgAuthClusterResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class DeleteClusterOrgAuthClusterResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: DeleteClusterOrgAuthClusterResponseBodyData;

  constructor(
    err: DeleteClusterOrgAuthClusterResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "DeleteClusterOrgAuthClusterResponseBody";
  }
}

/**
 * Bad request
 */
export type DeleteClusterOrgResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class DeleteClusterOrgResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: DeleteClusterOrgResponseBodyData;

  constructor(
    err: DeleteClusterOrgResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "DeleteClusterOrgResponseBody";
  }
}

/** @internal */
export const DeleteClusterOrgAuthClusterResponse429ResponseBody$inboundSchema:
  z.ZodType<
    DeleteClusterOrgAuthClusterResponse429ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new DeleteClusterOrgAuthClusterResponse429ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type DeleteClusterOrgAuthClusterResponse429ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const DeleteClusterOrgAuthClusterResponse429ResponseBody$outboundSchema:
  z.ZodType<
    DeleteClusterOrgAuthClusterResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    DeleteClusterOrgAuthClusterResponse429ResponseBody
  > = z.instanceof(DeleteClusterOrgAuthClusterResponse429ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const DeleteClusterOrgAuthClusterResponse409ResponseBody$inboundSchema:
  z.ZodType<
    DeleteClusterOrgAuthClusterResponse409ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new DeleteClusterOrgAuthClusterResponse409ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type DeleteClusterOrgAuthClusterResponse409ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const DeleteClusterOrgAuthClusterResponse409ResponseBody$outboundSchema:
  z.ZodType<
    DeleteClusterOrgAuthClusterResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    DeleteClusterOrgAuthClusterResponse409ResponseBody
  > = z.instanceof(DeleteClusterOrgAuthClusterResponse409ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const DeleteClusterOrgAuthClusterResponse404ResponseBody$inboundSchema:
  z.ZodType<
    DeleteClusterOrgAuthClusterResponse404ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new DeleteClusterOrgAuthClusterResponse404ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type DeleteClusterOrgAuthClusterResponse404ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const DeleteClusterOrgAuthClusterResponse404ResponseBody$outboundSchema:
  z.ZodType<
    DeleteClusterOrgAuthClusterResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    DeleteClusterOrgAuthClusterResponse404ResponseBody
  > = z.instanceof(DeleteClusterOrgAuthClusterResponse404ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const DeleteClusterOrgAuthClusterResponseResponseBody$inboundSchema:
  z.ZodType<
    DeleteClusterOrgAuthClusterResponseResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new DeleteClusterOrgAuthClusterResponseResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type DeleteClusterOrgAuthClusterResponseResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const DeleteClusterOrgAuthClusterResponseResponseBody$outboundSchema:
  z.ZodType<
    DeleteClusterOrgAuthClusterResponseResponseBody$Outbound,
    z.ZodTypeDef,
    DeleteClusterOrgAuthClusterResponseResponseBody
  > = z.instanceof(DeleteClusterOrgAuthClusterResponseResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const DeleteClusterOrgAuthClusterResponseBody$inboundSchema: z.ZodType<
  DeleteClusterOrgAuthClusterResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new DeleteClusterOrgAuthClusterResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type DeleteClusterOrgAuthClusterResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const DeleteClusterOrgAuthClusterResponseBody$outboundSchema: z.ZodType<
  DeleteClusterOrgAuthClusterResponseBody$Outbound,
  z.ZodTypeDef,
  DeleteClusterOrgAuthClusterResponseBody
> = z.instanceof(DeleteClusterOrgAuthClusterResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));

/** @internal */
export const DeleteClusterOrgResponseBody$inboundSchema: z.ZodType<
  DeleteClusterOrgResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new DeleteClusterOrgResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type DeleteClusterOrgResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const DeleteClusterOrgResponseBody$outboundSchema: z.ZodType<
  DeleteClusterOrgResponseBody$Outbound,
  z.ZodTypeDef,
  DeleteClusterOrgResponseBody
> = z.instanceof(DeleteClusterOrgResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
